import React from "react";
import { Button, Popup, PopupSection } from "@flixbus/honeycomb-react";
import styles from "../../CostPanel.module.scss";

interface DiscardDialogProps {
  active: boolean;
  onKeepEditing: () => void;
  onDiscard: () => void;
}

const DiscardDialog: React.FC<DiscardDialogProps> = ({
  active,
  onKeepEditing,
  onDiscard,
}) => (
  <Popup
    active={active}
    onOverlayClick={onKeepEditing}
    extraClasses={styles.confirmPopup}
  >
    <PopupSection type="title">Discard your changes?</PopupSection>
    <PopupSection type="content">
      Switching will replace your unsaved formula edits.
    </PopupSection>
    <PopupSection type="actions">
      <Button appearance="secondary" onClick={onKeepEditing}>
        Keep editing
      </Button>
      <Button appearance="danger" onClick={onDiscard}>
        Discard
      </Button>
    </PopupSection>
  </Popup>
);

export default DiscardDialog;
